import React from "react";
import BeneficariesView from "../BeneficariesView/BeneficariesView";
import Icon1 from "../../images/gbrFarmerBenefits/pay-per-click.svg";
// Main component for PlantQA
const PlantQA = () => {
  // List of features provided for the Plant QA role
  const features = [
    {
      image: Icon1,
      title: "Traceability & Recall Management",
      bodycopy:
        "Ensures end-to-end tracking of raw materials and finished products to manage recalls efficiently.",
    },
    {
      image: Icon1,
      title: "Risk Assessment & Preventive Actions",
      bodycopy:
        "Identifies quality risks and recommends preventive measures.",
    },
    {
      image: Icon1,
      title: "Data Analytics & Reporting",
      bodycopy:
        "Provides detailed reports on quality performance and deviations for continuous improvement.",
    },
  ];

  // List of benefits of the Plant QA role
  const benefits = [
    {
      image: Icon1,
      title: "Improved Product Quality",
      bodycopy:
        "Ensures consistent product quality, leading to higher customer satisfaction and reduced rejections.",
    },
    {
      image: Icon1,
      title: "Traceability & Risk Mitigation",
      bodycopy:
        "End-to-end tracking of ingredients and production batches to quickly manage recalls and quality issues.",
    },
    {
      image: Icon1,
      title: "Better Decision-Making",
      bodycopy:
        "Data analytics and reporting provide insights for continuous quality improvement and cost reduction.",
    },
  ];

  return (
    <>
      {/* Component to display banner, features and benefits of the Plant QA role */}
      <BeneficariesView title="Plant QA" features={features} benefits={benefits} />
    </>
  );
};

export default PlantQA;
